<template>
  <DashboardLayout :hide-sidebar="hideSidebar">
    <bert-loading 
      v-if="isLoading" 
      :fullscreen="true" 
      size="lg" 
      text="Loading"
    />
    
    <div v-else class="page-container">
      <!-- Page Header -->
      <PageHeader
        :title="pageTitle"
        :show-back-button="showBackButton"
        :show-notification="showNotification"
        :notification-text="notificationText"
        :notification-button-text="notificationButtonText"
        @back="handleBack"
        @notification-click="handleNotificationClick"
      />

      <!-- Banner Carousel (optional) -->
      <BannerCarousel
        v-if="showBanner"
        :banner-items="bannerItems"
        :autoplay="bannerAutoplay"
        :loop="bannerLoop"
        :show-pagination="bannerShowPagination"
        :height="bannerHeight"
        :mobile-height="bannerMobileHeight"
        :placeholder-text="bannerPlaceholderText"
        @banner-click="handleBannerClick"
      />

      <!-- Main Content Slot -->
      <div class="page-content">
        <slot></slot>
      </div>

      <!-- Page Footer -->
      <PageFooter
        :show-sponsors="showSponsors"
        :sponsor-title="sponsorTitle"
        :sponsors="sponsors"
        :copyright-text="copyrightText"
      />
    </div>
  </DashboardLayout>
</template>

<script>
import AppDashboardLayout from './DashboardLayout.vue';
import AppPageHeader from './PageHeader.vue';
import AppPageFooter from './PageFooter.vue';
import AppBannerCarousel from './BannerCarousel.vue';
import BertLoading from '@/components/ui/Loading.vue'

export default {
  name: "AppPageLayout",
  components: {
    DashboardLayout: AppDashboardLayout,
    PageHeader: AppPageHeader,
    PageFooter: AppPageFooter,
    BannerCarousel: AppBannerCarousel,
    BertLoading,
  },
  props: {
    // Layout props
    hideSidebar: {
      type: Boolean,
      default: false
    },
    
    // Loading state
    isLoading: {
      type: Boolean,
      default: false
    },
    
    // Header props
    pageTitle: {
      type: String,
      required: true
    },
    showBackButton: {
      type: Boolean,
      default: false
    },
    showNotification: {
      type: Boolean,
      default: false
    },
    notificationText: {
      type: String,
      default: ""
    },
    notificationButtonText: {
      type: String,
      default: ""
    },
    // Banner props
    showBanner: {
      type: Boolean,
      default: false
    },
    bannerItems: {
      type: Array,
      default: () => []
    },
    bannerAutoplay: {
      type: Boolean,
      default: true
    },
    bannerLoop: {
      type: Boolean,
      default: true
    },
    bannerShowPagination: {
      type: Boolean,
      default: true
    },
    bannerHeight: {
      type: String,
      default: "300px"
    },
    bannerMobileHeight: {
      type: String,
      default: "180px"
    },
    bannerPlaceholderText: {
      type: String,
      default: "No banners available"
    },
    // bannerLocation: {
    //   type: String,
    //   default: ""
    // },
    // Footer props
    showSponsors: {
      type: Boolean,
      default: true
    },
    sponsorTitle: {
      type: String,
      default: "Sponsor Hadiah Bert Points"
    },
    sponsors: {
      type: Array,
      default: () => []
    },
    copyrightText: {
      type: String,
      default: "© Copyright 2025 Bert Solution All rights reserved."
    }
  },
  methods: {
    handleBack() {
      this.$emit('back');
    },
    
    handleNotificationClick() {
      this.$emit('notification-click');
    },
    
    handleBannerClick(banner) {
      this.$emit('banner-click', banner);
    }
  }
};
</script>

<style scoped>
.page-container {
  position: relative;
  min-height: 100vh;
  width: 100%;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading-content {
  text-align: center;
}

.page-content {
  flex: 1;
  position: relative;
  z-index: 5;
  background-color: transparent;
}

/* Ensure proper spacing and layout */
.page-container > * {
  position: relative;
  z-index: 5;
}
</style>